var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#474747",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m150.731 287.099s20.981-29.328 79.739-34.701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m157.173 141.311c-21.765 45.676-9.984 54.424-6.441 100.836 3.542 46.412 0 58.201-19.405 94.931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m184.125 132.182-6.971 4.219c-7.207 4.362-15.778 5.892-24.05 4.291l-17.987-3.481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m241.431 449.049c-76.022 16.742-149.401-25.766-198.158-37.514-15.957-3.845-27.446-17.768-28.208-34.164-.085-92.224 54.645-218.747 89.685-289.217 3.414-6.865 8.24-12.92 14.169-17.781 17.252-14.14 58.697-38.984 58.697-38.984l41.991 8.096 37.74 32.625c9.274 10.704.044 21.912-16.292 23.055l-9.265.81"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m171.105 120.376 22.372 16.112c3.99 2.873 9.38 2.838 13.331-.088 4.177-3.093 5.707-8.636 3.707-13.434l-13.41-32.567-28.373-9.884"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m209.035 118.771c3.75 3.908 9.596 4.944 14.46 2.562 5.142-2.518 7.904-8.218 6.693-13.814l-10.925-37.134-30.755-11.828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m260.315 84.524c11.433 5.183 12.775 21.96 2.757 31.649l-32.602 31.649s-17.469-10.201-17.421-26.256"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#474747",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m251.566 299.88v94.55c0 13.506 7.205 25.986 18.902 32.738l81.883 47.275c11.696 6.753 26.107 6.753 37.803 0l81.883-47.275c11.696-6.753 18.902-19.233 18.902-32.738v-94.55c0-13.506-7.205-25.986-18.902-32.738l-81.883-47.275c-11.696-6.753-26.107-6.753-37.803 0l-81.883 47.275c-11.697 6.752-18.902 19.232-18.902 32.738z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m392.806 272.771-65.41 84.817h35.633l-15.076 63.951 67.155-87.249h-37.004z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.b736d9653a18719c64fbad98b659afb4.svg";
export { ForwardRef as ReactComponent };